import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import Dynamic_PR_table from "../../../../components/Dynamic_PR_table";
import { GetServiceCaller } from "../../../../services/serviceCaller";
import { API_URL } from "../../../../constants";
import { useNavigate } from "react-router-dom";

const AssetCategory = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(updateNavbarHeading("Asset Category Master"));
    }, [])

    const [searchTerm, setSearchTerm] = useState("");
    const [assetCategorydata, setAssetCategoryData] = useState([]);

    const [loading, setLoading] = useState(true);

    const columns = {
        AssetTypes: { text: "Type", align: "start", visible: true },
        Name: { text: "Category", align: "left", visible: true },
        Code: { text: "Code", align: "strat", visible: false },
        AssetCode: { text: "Asset Code", align: "start", visible: true },
        BrandName: { text: "Make Name", align: "left",type:"HTML", visible: true },
        IsInActive: { text: "Active", align: "center", visible: true }
    }

    useEffect(() => {
        fetchAssetCategory();
    }, [])


    const [apiStatus, SetApiStatus] = useState(undefined);

    const fetchAssetCategory = async () => {
        try {
            
            const response = await GetServiceCaller(`${API_URL}asset-category`);
            SetApiStatus(response?.status);
            if (response?.status === 200) {
                const fetchData = response?.data?.data?.header;
                setAssetCategoryData(fetchData);
                setLoading(false);
            }
            else {
                console.error(
                    "Failed to fetch asset categories. Server responded with status:",
                    response
                );
            }
        } 
        catch (error) {

            console.log("response-->",error);
            
        }
    }

    const handleEdit = (id) => {
        navigate(`/asset-category/edit/${id.ID}`);
    }

    const handleAddNewAssetCategory = () => {
        navigate("/asset-category/add");
    }

    return (
        <>
            <div className="container-fluid" id="skill_section">
                <div className="container-fluid" id="skill-table-area">
                    <div className="row">                    
                <Dynamic_PR_table
                        data={assetCategorydata}
                        columns={columns}
                        itemsPerPage={8}
                        searchTerm={searchTerm}
                        setSearchTerm={setSearchTerm}
                        showIcon1={true}
                        showIcon2={false}
                        isSorting={true}
                        isApiStatus={apiStatus}
                        isRequiredStatus={true}
                        showIcon3={false}
                        showIcon4={false}
                        showIcon5={false}
                        isSrNoRequired={true}
                        isActionRequired={true}
                        isAddNewBtnRequired={true}
                        handleIcon1={handleEdit}
                        handleAddNew={handleAddNewAssetCategory}
                        add
                        more
                        function
                        icons={{
                            Icon1: <i class="bi bi-pencil-square icons"></i>,
                            Icon1Text: " Edit",
                        }}
                    />
                    </div>
                </div>
            </div>
        </>
    )
}

export default AssetCategory;